module.exports = __webpack_public_path__ + "static/media/right-chevron.524227ca.png";